import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/permission/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/permission/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/permission/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/permission/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/permission/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/permission/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/permission/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/permission/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/permission/update/batch',
    method: 'POST',
    data})
}

   